import {Pipe, PipeTransform} from '@angular/core';
import {GwrGrundstueckNummerListEntry} from '../../core/gwr-api/model/gwrGrundstueckNummerListEntry';
import {TranslateNamePipe} from '../../shared/pipes/simple/translate-name.pipe';

@Pipe({
  name: 'gwrGrundstuecknummerPipe'
})
export class GwrGrundstuecknummerPipe implements PipeTransform {


  constructor(private translateName: TranslateNamePipe) {
  }

  transform(value: GwrGrundstueckNummerListEntry): string {
    let nummer = this.formatGemeinde(value);
    nummer += value.nummer;
    nummer += this.combineIfNotNull('-', value.nummerZusatz);
    nummer += this.combineIfNotNull('-', value.nummer3);
    nummer += this.combineIfNotNull('-', value.nummer4);
    return nummer;
  }

  private formatGemeinde(value: GwrGrundstueckNummerListEntry) {
    let gemeinde = '';
    if (value.gemeinde != null) {
      gemeinde += value.gemeinde.name ? value.gemeinde.name + " " : "";
      gemeinde += value.gemeinde.bfsNummer + this.combineIfNotNull(".", value.gemeinde.kreisNummer);
      gemeinde += '/';
    }
    return gemeinde;
  }

  private combineIfNotNull(delimiter: string, value: any) {
    if (value) {
      return delimiter + value.toString();
    }
    return '';
  }

}
